import { Registration } from '@stax-core/types-omni';

export const elavonMapper = (r: Registration) => ({});
